import React, { useContext, useEffect, useState } from "react"

import VoteButtonUI from "steps/shared/VoteButtonsUI"
import VoteButtonsResult from "steps/shared/VoteButtonsResult"

import { submitVote, getVotes } from 'services/article'
import { modalContext } from 'global/context/sub-contexts/modalContext';

/*
    TODO: this component gets votes whenever it loads -
        which might be before the user has logged in
        update useEffect to look for changes to user profile
*/

const ArticleVoting = ({articleId, upVotetxt, downVotetxt, upVoteIcon, downVoteIcon, selection=undefined, upvotes, downvotes, onVote = () => {} }) => {

    const [isVoting, setIsVoting] = useState(false);
    const [pollResults, setPollResults] = React.useState()
    const voteError = false

    const { showSignInModalTab } = useContext(modalContext)

    useEffect(() => {
        console.log("useEffect")
        const loadVoteInfo = async () => {
            try {
                const results = await getVotes(articleId)
                console.log('getting votes: ',results)
                if (results.detail.userHasVoted) {
                  setPollResults({
                    upvotes: results.detail.upvotes,
                    downvotes: results.detail.downvotes,
                    totalResultsCount: results.detail.upvotes + results.detail.downvotes,
                    selected: ''
                  });
                }
            } catch (e) {
                console.log(e)
                setPollResults(undefined)
            }

        }


        // we were told what to display, so display it
        if (selection && (upvotes + downvotes)) {
            setPollResults({ upvotes: upvotes,
                            downvotes: downvotes,
                            selected: selection,
                            totalResultsCount: upvotes + downvotes
            })
        } else {
            loadVoteInfo()
        }


    }, [articleId, selection, upvotes, downvotes, setPollResults])


    const handleDispatchedVote = async (id, selection) => {
        setIsVoting(true)

      try {
          const responseData = await submitVote(id, selection);
          console.log(responseData)
          setPollResults({
            upvotes: responseData.detail.upvotes,
            downvotes: responseData.detail.downvotes,
            totalResultsCount: responseData.detail.upvotes + responseData.detail.downvotes,
            selected: selection
          });
          setIsVoting(false)

          onVote()

      } catch (e) {
        console.log(e)
      }
    }



    return (
        <>
          <div className="voting">
        { !pollResults &&
            <VoteButtonUI
              id={articleId}
              upVotetxt={upVotetxt}
              downVotetxt={downVotetxt}
              upVoteIcon={upVoteIcon}
              downVoteIcon={downVoteIcon}
              isVoting={isVoting}
              dispatchVote={handleDispatchedVote}
              error={voteError}
              alreadyComplete={false}
            />
        }
        { pollResults &&
            <VoteButtonsResult
                selected={ pollResults.selected }
                upvotes={pollResults.upvotes}
                downvotes={pollResults.downvotes}
                totalResultsCount={pollResults.totalResultsCount}
                upVotetxt={upVotetxt}
                downVotetxt={downVotetxt}
            />
        }
          </div>
        </>
    )
  }

export default ArticleVoting